import { Box } from '@mui/material';
//import { useParams } from 'react-router-dom';
import ChatPanelHome from '../components/ChatPanelHome';

function HomeChat() {
  //const { homeId } = useParams<{ homeId: string }>();

  return (
    <Box sx={{ 
      flex: 1,
      minHeight: 0,
      position: 'relative'
    }}>
      <ChatPanelHome />
    </Box>
  );
}

export default HomeChat;